import Vue from "vue";
import Vuetify from "vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import helpers from "./helpers";
import SisApi from "./sis-api";
import SisSocket from "./sis-socket";

import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import "vuetify/dist/vuetify.min.css";

import loginLayout from "./layouts/loginLayout.vue";
import mainLayout from "./layouts/mainLayout.vue";

import axios from "axios";
import VueAxios from "vue-axios";
import VueSocialauth from "vue-social-auth";
Vue.use(VueAxios, axios);
Vue.use(VueSocialauth, {
  providers: {
    google: {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      redirectUri: window.location.protocol + "//" + window.location.host,
      scope: "profile email",
      prompt: "select_account",
    },
  },
});

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      store.state.loginRequired = true;
    }
    return Promise.reject(error);
  }
);

Vue.use(Vuetify);
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi",
});

Vue.use(helpers);
Vue.use(SisApi);
Vue.use(SisSocket);

Vue.component("login-layout", loginLayout);
Vue.component("main-layout", mainLayout);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    can: function(perms) {
      let allow = false;
      if (!store.state.u.permissions) {
        return allow;
      }
      perms.forEach((perm) => {
        if (store.state.u.permissions[perm]) {
          allow = true;
        }
      });
      return allow;
    },
    isStudent: function(perm) {
      return store.state.u.type == "Student";
    },
    isSystemAdmin: function(perm) {
      return store.state.u.type == "System Admin";
    },
    isStaff: function(perm) {
      return store.state.u.type == "Staff";
    },
    hasSchedule: function(perm) {
      return store.state.u.has_schedule;
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
